export default [
    {
        name:"QueryDesign",
        path:"QueryDesign",
        component:()=>import("@/view/WebViews/Trademark/QueryDesign"),
        meta:{
            title:"查询与设计",
        }
    },
    {
        name:"RenewalChange",
        path:"RenewalChange",
        component:()=>import("@/view/WebViews/Trademark/RenewalChange"),
        meta:{
            title:"续展与变更",
        }
    },
    {
        name:"OppositionWithdrawal",
        path:"OppositionWithdrawal",
        component:()=>import("@/view/WebViews/Trademark/OppositionWithdrawal"),
        meta:{
            title:"异议与撤三",
        }
    },
    {
        name:"DefenseReexamination",
        path:"DefenseReexamination",
        component:()=>import("@/view/WebViews/Trademark/DefenseReexamination"),
        meta:{
            title:"答辩与复审",
        }
    },
    {
        name:"MonitoringRightsProtection",
        path:"MonitoringRightsProtection",
        component:()=>import("@/view/WebViews/Trademark/MonitoringRightsProtection"),
        meta:{
            title:"监测与维权",
        }
    },
]